import { motion } from "framer-motion";
import { PAYMENTS, CONTACT } from "@/data/services";
import { TID } from "@/constants/testIds/site";

export default function Payments() {
  return (
    <section
      data-testid={TID.payments.section}
      className="relative py-24 px-6 md:px-10 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.4em] text-white/50 mb-4 flex items-center gap-3">
              <span className="dot-gold" />
              Paiement 100% Mobile Money
            </div>
            <h2 className="font-display text-4xl md:text-5xl tracking-tighter text-white leading-[0.95]">
              Payez comme <span className="text-gold-gradient italic">vous voulez</span>.
            </h2>
            <p className="text-white/60 mt-5 text-sm leading-relaxed">
              Rapide, sécurisé, sans carte bancaire. Choisissez votre opérateur
              préféré et validez en quelques secondes.
            </p>

            <div className="mt-6 space-y-3">
              <div className="p-4 rounded-xl border border-[#FF7900]/30 bg-[#FF7900]/5">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#FF7900] mb-1">
                  Orange Money · Paiement direct
                </div>
                <div
                  className="text-white font-display text-xl tracking-tight select-all"
                  data-testid="orange-money-number"
                >
                  {CONTACT.orangeMoney}
                </div>
              </div>
              <div className="p-4 rounded-xl border border-[#FFCC00]/30 bg-[#FFCC00]/5">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFCC00] mb-1">
                  MTN Money · Paiement direct
                </div>
                <div
                  className="text-white font-display text-xl tracking-tight select-all"
                  data-testid="mtn-money-number"
                >
                  {CONTACT.mtnMoney}
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-4">
            {PAYMENTS.map((p, i) => (
              <motion.div
                key={p.name}
                data-testid={TID.payments.badge(p.name)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="relative rounded-xl p-6 border border-white/10 bg-[#111] hover:border-white/25 transition-colors overflow-hidden group"
                style={{
                  boxShadow: `inset 0 0 0 0 ${p.color}`,
                }}
              >
                <div
                  className="absolute -bottom-8 -right-8 w-28 h-28 blur-3xl opacity-40 group-hover:opacity-70 transition-opacity"
                  style={{ background: p.color }}
                />
                <div
                  className="w-10 h-10 rounded-full mb-4 grid place-items-center font-display text-lg"
                  style={{
                    background: `${p.color}20`,
                    color: p.color,
                    border: `1px solid ${p.color}55`,
                  }}
                >
                  {p.name.charAt(0)}
                </div>
                <div className="text-white font-semibold text-lg tracking-tight">
                  {p.name}
                </div>
                <div className="text-white/45 text-xs mt-1 uppercase tracking-widest">
                  {p.note || "Mobile Money"}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
